<template>
	<layout-default class="layout-admin">
		<template #header-tools>
			<div class="layout-admin__nav">
				<nav-tabs :items="navItems" />
			</div>
		</template>

		<slot />

		<rotate-device />
	</layout-default>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import NavTabs from '@/components/nav/NavTabs.vue';
import RotateDevice from '@/components/RotateDevice.vue';
import { NavTabsItemModel } from '@/store/models/NavTabsItem';

import LayoutDefault from './LayoutDefault.vue';

export default defineComponent({
	components: {
		LayoutDefault,
		NavTabs,
		RotateDevice,
	},

	computed: {
		navItems(): NavTabsItemModel[] {
			return [
				{
					label: 'Orders',
					to: { name: 'admin-orders' },
					matched_routes: ['admin-orders', 'admin-orders-list'],
				},
				{
					label: 'Organizations',
					to: { name: 'admin-organisations' },
					matched_routes: [
						'admin-organisations',
						'admin-organisations-create',
						'admin-organisations-details',
						'admin-organisations-update',
						'admin-addresses-create',
						'admin-addresses-update',
					],
				},
				{
					label: 'Users',
					to: { name: 'admin-users' },
					matched_routes: ['admin-users', 'admin-users-create', 'admin-users-edit'],
				},
				{
					label: 'Materials',
					to: { name: 'admin-materials' },
					matched_routes: ['admin-materials'],
				},
				{
					label: 'Norms',
					to: { name: 'admin-norms' },
					matched_routes: ['admin-norms', 'admin-norms-product'],
				},
			];
		},
	},
});
</script>

<style lang="scss">
.layout-admin {
	&__nav {
		grid-column: 7 / span 12;
		align-self: center;

		@include max-lg-and-portrait {
			grid-column: 6 / span 16;
			margin-right: 0;
			margin-left: -3rem;
		}
	}
}
</style>
